//用户个人能力管理
export default [

	// 我的页
	// {
	// 	path: '/user',
	// 	name: 'user',
	// 	component: () => import('../../views/user/user.vue'),
	// 	// meta: {keepAlive: true } // 缓存
	// },
	// 单点登录页
	{
		path: '/logon',
		name: 'logon',
		meta: {
			index: 0,
			keepAlive: false,
		},
		component: () => import('../../views/user/logon.vue'),
	},
	// 登录页
	{
		path: '/login',
		name: 'login',
		meta: {
			index: 0,
			keepAlive: false,
		},
		component: () => import('../../views/user/login.vue'),
	},
	// 注册页
	{
		path: '/register',
		name: 'register',
		meta: {
			index: 1,
			keepAlive: false,
		},
		component: () => import('../../views/user/register.vue'),
	},
	// 忘记密码页
	{
		path: '/forgot',
		name: 'forgot',
		meta: {
			index: 1,
			keepAlive: false,
		},
		component: () => import('../../views/user/forgot.vue'),
	},

	// 个人签名
	{
		path: '/esignature',
		name: 'esignature',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/user/signature/esignature.vue')
	},
	// 上传个人签名图片
	{
		path: '/uploadsignature',
		name: 'uploadsignature',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/signature/uploadSignature.vue')
	},
	// 一键生成个人签名图片
	{
		path: '/createsignature',
		name: 'createsignature',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/signature/createSignature.vue')
	},
	// 手写签名
	{
		path: '/writesignaturepad',
		name: 'writesignaturepad',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/signature/writeSignaturePad.vue')
	},

	// 个人实人认证三步合一
	{
		path: '/personalauthflow',
		name: 'personalauthflow',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/user/auth/personalAuthFlow.vue')
	},
	// 个人实人认证方式选择
	{
		path: '/personalauthselectstyle',
		name: 'personalauthselectstyle',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/user/auth/personalAuthSelectStyle.vue')
	},
	// 个人实人认证完成结果
	{
		path: '/personalauthcomplete',
		name: 'personalauthcomplete',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/user/auth/personalAuthComplete.vue')
	},

	// 设置页面
	{
		path: '/settings',
		name: 'settings',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/user/settings.vue')
	},
	// 个人信息
	{
		path: '/userinfo',
		name: 'userinfo',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/user/userInfo.vue')
	},
	// 账户与安全
	{
		path: '/accountsafe',
		name: 'accountsafe',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/accountSafe.vue')
	},
	// 账户与安全
	{
		path: '/accountlogoff',
		name: 'accountlogoff',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/accountLogOff.vue')
	},
	// 修改密码
	{
		path: '/changepassword',
		name: 'changepassword',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/changePassword.vue')
	},
	// 更改手机号
	{
		path: '/changemobile',
		name: 'changemobile',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/changeMobile.vue')
	},

	// 关于
	{
		path: '/about',
		name: 'about',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/about.vue')
	},

	// 通知设置
	{
		path: '/notifysettings',
		name: 'notifysettings',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/notifySettings.vue')
	},
	// 个人节能减碳汇总
	{
		path: '/energyconservationselfoverview',
		name: 'energyconservationselfoverview',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/energyconservation/EnergyConservationSelf0verview.vue')
	},
	// 个人节能减碳明细
	{
		path: '/energyconservationselflist',
		name: 'energyconservationselflist',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/user/energyconservation/energyConservationSelfList.vue')
	},
	// 镇海炼化协议
	{
		path: '/agreement',
		name: 'agreement',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/zhlh/agreement.vue')
	},

]